/* eslint-disable */
import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import 'contents/assets/scss/page/student.scss';
import Tab from '../../component/Inc/Tab';
import Paging from '../../component/Inc/Paging';
function TestReport() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '전체', value: 0},
    {title: '중간고사', value: 1},
    {title: '기말고사', value: 2, type: 'new'}
  ];
  return (
    <main className="com_container p_test_report">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_18">시험 전후 상담보고서</h2>
          <Link to="../Student/TestReport/Form" className="com_btn orange s btn_plus">시험 전후 상담보고서 등록</Link>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <button className="com_btn lightGray s">내 작성목록</button>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <div className="board_select">
                <div className="check">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">전체</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">중3</label>
                  <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                  <label htmlFor="rdo03">고2이하</label>
                  <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                  <label htmlFor="rdo04">고3</label>
                </div>
              </div>
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <section className="com_board_search end">
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">2023</button>
                  <button className="com_btn line gray s">2022</button>
                </div>
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <button className="com_btn gray s">조회</button>
                </div>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="60" />
                <col width="100" />
                <col width="100" />
                <col width="100" />
                <col width="100" />
                <col width="100" />
                <col width="100" />
                <col width="100" />
                <col width="100" />
                <col width="100" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th>등록자</th>
                  <th>학생명</th>
                  <th>시험명</th>
                  <th>학년</th>
                  <th>목표 수능등급</th>
                  <th>과목 평균/등급</th>
                  <th>교사</th>
                  <th>담임</th>
                </tr>
              </thead>
              <tbody>
                <tr className="selected">
                  <td>1</td>
                  <td>2022,08,25</td>
                  <td>
                    <button className="btn_link">김선생103</button>
                  </td>
                  <td>
                    <button className="btn_link">가길동(남/17)</button>
                  </td>
                  <td>
                    <button className="btn_link">2학기 / 중간</button>
                  </td>
                  <td>
                    <button className="btn_link">중3</button>
                  </td>
                  <td>1</td>
                  <td>78 / 2</td>
                  <td>
                    <button className="btn_link">홍길동204</button>
                  </td>
                  <td>
                    <button className="btn_link">홍길동204</button>
                  </td>
                </tr>
                {[...Array(10)].map((i, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>2022,08,25</td>
                    <td>
                      <button className="btn_link">김선생103</button>
                    </td>
                    <td>
                      <button className="btn_link">가길동(남/17)</button>
                    </td>
                    <td>
                      <button className="btn_link">2학기 / 중간</button>
                    </td>
                    <td>
                      <button className="btn_link">중3</button>
                    </td>
                    <td>1</td>
                    <td>78 / 2</td>
                    <td>
                      <button className="btn_link">홍길동204</button>
                    </td>
                    <td>
                      <button className="btn_link">홍길동204</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 상세보기 */}
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <div className="count">
                <button className="btn_edit" />
              </div>
            </div>
            <table className="com_board_list type_row">
              <colgroup>
                <col width="148" />
                <col width="auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th>학생명</th>
                  <td>홍길동202 | 수학1T | 고1</td>
                </tr>
                <tr>
                  <th>교사 / 담임</th>
                  <td>김교사103 / 김담임120</td>
                </tr>
                <tr>
                  <th>최근/목표 수능등급</th>
                  <td>6등급 / 3등급</td>
                </tr>
                <tr>
                  <th>평가기간</th>
                  <td>2022, 08, 25 ~ 2022, 09, 15</td>
                </tr>
                <tr>
                  <th>시험명</th>
                  <td>2학기 / 중간 고사</td>
                </tr>
                <tr>
                  <th>평균 점수</th>
                  <td>85점</td>
                </tr>
                <tr>
                  <th>내용</th>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name">김관리102 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                  <div className="btn_wrap">
                    <button className="btn_edit"></button>
                    <button className="btn_delete"></button>
                  </div>
                </div>
                <hr className="com_divider" />
                <div className="info">수고 하셨습니다.</div>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_comment_wrap">
              <div className="comment_input">
                <textarea type="text" className="textarea" placeholder="김담임 답변하기" />
                <button className="com_btn gray l">등록</button>
              </div>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
}

export default TestReport;
